import './style.scss'

export default function DataAttribution() {
  return (
    <div className="cst-data-attribution">
      <small>
        Data sources:&nbsp;
        <a
          href="https://fluxnet.org/data/data-policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          FLUXNET2015
        </a>
        ,&nbsp;
        <a
          href="https://ameriflux.lbl.gov/data/data-policy"
          target="_blank"
          rel="noopener noreferrer"
        >
          AmeriFlux
        </a>
        ,&nbsp;
        <a
          href="https://cds.climate.copernicus.eu/datasets/sis-agrometeorological-indicators"
          target="_blank"
          rel="noopener noreferrer"
        >
          AgERA5
        </a>
        ,&nbsp;
        <a
          href="https://www.usgs.gov/centers/eros/data-citation"
          target="_blank"
          rel="noopener noreferrer"
        >
          Landsat
        </a>
        .&nbsp;Licenses:&nbsp;
        <a
          href="https://creativecommons.org/licenses/by/4.0/"
          target="_blank"
          rel="noopener noreferrer"
        >
          CC BY 4.0
        </a>
        &nbsp;(except Landsat, Public Domain).
      </small>
    </div>
  )
}
